import React from 'react';
import styles from './alert.module.scss';

import CloseIcon from '../../img/icons/closeIcon';

const Alert = (props) => {

  const { text, onClick, color } = props;

  return (
      <div className={styles.alert} style={ color === 'green' ? {backgroundColor: '#4DD686'} : {backgroundColor: '#FF3366'}}>
        {text}
        <CloseIcon className="closeIcon" size="10" color="#fff" onClick={onClick} />
      </div>
    );
}

export default Alert;
